// Generated on 2026-10-19T22:56:30.646Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "355439"
  },
  {
    "marca": "HONDA",
    "busquedas": "339434"
  },
  {
    "marca": "FORD",
    "busquedas": "276659"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "166636"
  },
  {
    "marca": "NISSAN",
    "busquedas": "153986"
  },
  {
    "marca": "KIA",
    "busquedas": "82375"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "78426"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "48342"
  },
  {
    "marca": "MAZDA",
    "busquedas": "48316"
  },
  {
    "marca": "JEEP",
    "busquedas": "44814"
  },
  {
    "marca": "ISUZU",
    "busquedas": "28270"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "15708"
  },
  {
    "marca": "BMW",
    "busquedas": "11790"
  },
  {
    "marca": "DODGE",
    "busquedas": "9323"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "8285"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "8016"
  },
  {
    "marca": "ACURA",
    "busquedas": "3086"
  },
  {
    "marca": "SCION",
    "busquedas": "2816"
  },
  {
    "marca": "SUBARU",
    "busquedas": "2377"
  },
  {
    "marca": "GMC",
    "busquedas": "2346"
  },
  {
    "marca": "MINI",
    "busquedas": "2314"
  },
  {
    "marca": "RAM",
    "busquedas": "2264"
  },
  {
    "marca": "LEXUS",
    "busquedas": "1729"
  },
  {
    "marca": "MERCURY",
    "busquedas": "1260"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "1194"
  },
  {
    "marca": "VOLVO",
    "busquedas": "990"
  },
  {
    "marca": "AUDI",
    "busquedas": "747"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "696"
  },
  {
    "marca": "HUMMER",
    "busquedas": "622"
  },
  {
    "marca": "SATURN",
    "busquedas": "551"
  },
  {
    "marca": "INFINITI",
    "busquedas": "517"
  },
  {
    "marca": "GEO",
    "busquedas": "455"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "357"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "319"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "293"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "291"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "164"
  },
  {
    "marca": "FIAT",
    "busquedas": "140"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "107"
  },
  {
    "marca": "BUICK",
    "busquedas": "106"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "95"
  },
  {
    "marca": "JMC",
    "busquedas": "73"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "59"
  },
  {
    "marca": "RENAULT",
    "busquedas": "47"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "25"
  },
  {
    "marca": "JAC",
    "busquedas": "22"
  },
  {
    "marca": "ZNA",
    "busquedas": "17"
  },
  {
    "marca": "CHANGAN",
    "busquedas": "17"
  },
  {
    "marca": "FOTON",
    "busquedas": "10"
  },
  {
    "marca": "JIM",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "CHERY",
    "busquedas": "5"
  },
  {
    "marca": "TESLA",
    "busquedas": "4"
  },
  {
    "marca": "SAAB",
    "busquedas": "3"
  },
  {
    "marca": "KARMA",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "ROLLS-ROYCE",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "CODA",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "SSANGYONG",
    "busquedas": "1"
  },
  {
    "marca": "GREAT WALL MOTOR",
    "busquedas": "1"
  },
  {
    "marca": "SMART",
    "busquedas": "1"
  },
  {
    "marca": "BUGATTI",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
